export default __webpack_public_path__ + "static/media/light_logo_text.7e2b0a11.svg";